import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
import { STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_BY_COLOR, ORDER_ASCENDING } from '../Utils/Constants';
const sFPControllerEndpoint = 'FirmPurchases';
const sCarsControllerEndpoint = 'Cars';


export class CarsListAPI {

  getCarsList(Id, page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_COLOR, order = ORDER_ASCENDING, searchBy = '', colorFilter = 0, optionalsFilter = []) {
    let params = {
      Id: Id,
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      params.searchBy = searchBy;
    if (colorFilter)
      params.colorFilter = colorFilter;
    if (optionalsFilter)
      params.optionalsFilter = optionalsFilter;
    return axios.get(getBackendURL() + sFPControllerEndpoint + '/GetFirmPurchasesCarsList', { params });
  }

  getMinimizedL4List(L1Id, page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_COLOR, order = ORDER_ASCENDING, colorFilter = 0, optionalsFilter = [], saleChannelFilter = [], reservationFilter = null, stockFilter = null) {
    let params = {
      L1Id,
      page,
      rowsPerPage,
      orderBy,
      order,
      colorFilter,
      optionalsFilter,
      saleChannelFilter,
      reservationFilter,
      stockFilter
    }

    return axios.get(getBackendURL() + sFPControllerEndpoint + '/GetMinimizedListL4', { params })
  }

  updateBulkSalesChannelByL4(ListCarIds = [], ListSalesChannelIds = [], ForceSave, isToChangeReservations) {
    let params = {
      ListCarIds,
      ListSalesChannelIds,
      ForceSave,
      isToChangeReservations
    };

    return axios.put(getBackendURL() + sFPControllerEndpoint + '/UpdateBulkSalesChannelByL4', params)
  }

  getColorsByL1Id(Id) {
    return axios.get(getBackendURL() + sFPControllerEndpoint + '/GetColorsByL1Id?L1Id=' + Id);
  }

  getOptionalsByL1Id(Id) {
    return axios.get(getBackendURL() + sFPControllerEndpoint + '/GetOptionalsByL1Id?L1Id=' + Id);
  }

  deleteCar(Id, ForceSave) {
    let params = {
      Id: Id,
      ForceSave: ForceSave
    }
    return axios.delete(getBackendURL() + sFPControllerEndpoint + '/DeleteCar', { params });
  }

  quitDeal(L4Id, forceSave) {
    return axios.put(getBackendURL() + sFPControllerEndpoint + '/QuitDeal?Id=' + L4Id + '&forceSave=' + forceSave);
  }

  updateCarInformation(dto) {
    return axios.put(getBackendURL() + sFPControllerEndpoint + '/UpdateCarInformation', dto);
  }

  updateCarInformationByLot(carDTO, lotId) {
    return axios.put(getBackendURL() + sCarsControllerEndpoint + '/UpdateCarsAndLotInformation?id=' + lotId, carDTO);
  }

  associateOrderToCar(carDTO) {
    return axios.put(getBackendURL() + sCarsControllerEndpoint + '/AssociateOrderToCar', carDTO);
  }

  getCarByL4Id(id) {
    return axios.get(getBackendURL() + sCarsControllerEndpoint + '/GetCarByL4Id?L4Id=' + id);
  }

  updateBulkOptionalsByL4(ListCarIds = [], ListOptionalsIds = [], ForceSave, isToChangeReservations) {
    let params = {
      ListCarIds,
      ListOptionalsIds,
      ForceSave,
      isToChangeReservations
    };

    return axios.put(getBackendURL() + sFPControllerEndpoint + '/UpdateBulkOptionalsByL4', params)
  }

}

export default CarsListAPI


// WEBPACK FOOTER //
// ./src/API/CarsListAPI.js